export const TASK_STATUS_ENUM = {
  CREATED: 'Created',
  ASSIGNED: 'Assigned',
  INPROGRESS: 'InProgress',
  COMPLETED: 'COMPLETE',
  CLOSED: 'Closed'
};
